import { render } from "./LoginWithOtp.vue?vue&type=template&id=3e3fc207&scoped=true"
import script from "./LoginWithOtp.vue?vue&type=script&lang=js"
export * from "./LoginWithOtp.vue?vue&type=script&lang=js"

import "./LoginWithOtp.vue?vue&type=style&index=0&id=3e3fc207&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3fc207"]])

export default __exports__